<kendo-editor [(ngModel)]="editorValue">
  <kendo-toolbar>
    <kendo-toolbar-buttongroup>
      <kendo-toolbar-button kendoEditorBoldButton *ngIf="configuration.BoldButton"></kendo-toolbar-button>
      <kendo-toolbar-button kendoEditorItalicButton *ngIf="configuration.ItalicButton"></kendo-toolbar-button>
      <kendo-toolbar-button kendoEditorUnderlineButton *ngIf="configuration.UnderlineButton"></kendo-toolbar-button>
      <kendo-toolbar-button
        kendoEditorStrikethroughButton
        *ngIf="configuration.StrikethroughButton"
      ></kendo-toolbar-button>
    </kendo-toolbar-buttongroup>

    <kendo-toolbar-buttongroup>
      <kendo-toolbar-button kendoEditorAlignLeftButton *ngIf="configuration.AlignLeftButton"></kendo-toolbar-button>
      <kendo-toolbar-button kendoEditorAlignCenterButton *ngIf="configuration.AlignCenterButton"></kendo-toolbar-button>
      <kendo-toolbar-button kendoEditorAlignRightButton *ngIf="configuration.AlignRightButton"></kendo-toolbar-button>
      <kendo-toolbar-button
        kendoEditorAlignJustifyButton
        *ngIf="configuration.AlignJustifyButton"
      ></kendo-toolbar-button>
    </kendo-toolbar-buttongroup>

    <kendo-toolbar-buttongroup>
      <kendo-toolbar-button
        kendoEditorInsertUnorderedListButton
        *ngIf="configuration.InsertUnorderedListButton"
      ></kendo-toolbar-button>
      <kendo-toolbar-button
        kendoEditorInsertOrderedListButton
        *ngIf="configuration.InsertOrderedListButton"
      ></kendo-toolbar-button>
      <kendo-toolbar-button kendoEditorIndentButton *ngIf="configuration.IndentButton"></kendo-toolbar-button>
      <kendo-toolbar-button kendoEditorOutdentButton *ngIf="configuration.OutdentButton"></kendo-toolbar-button>
    </kendo-toolbar-buttongroup>

    <kendo-toolbar-buttongroup>
      <kendo-toolbar-button kendoEditorSubscriptButton *ngIf="configuration.SubscriptButton"></kendo-toolbar-button>
      <kendo-toolbar-button kendoEditorSuperscriptButton *ngIf="configuration.SuperscriptButton"></kendo-toolbar-button>
    </kendo-toolbar-buttongroup>

    <kendo-toolbar-dropdownlist kendoEditorFormat *ngIf="configuration.FormatList"></kendo-toolbar-dropdownlist>
    <kendo-toolbar-button
      kendoEditorCleanFormattingButton
      *ngIf="configuration.CleanFormattingButton"
    ></kendo-toolbar-button>

    <kendo-toolbar-dropdownlist kendoEditorFontFamily *ngIf="configuration.FontFamilyList"></kendo-toolbar-dropdownlist>
    <kendo-toolbar-dropdownlist kendoEditorFontSize *ngIf="configuration.FontSizeList"></kendo-toolbar-dropdownlist>

    <kendo-toolbar-colorpicker kendoEditorForeColor *ngIf="configuration.ForeColorPicker"></kendo-toolbar-colorpicker>
    <kendo-toolbar-colorpicker kendoEditorBackColor *ngIf="configuration.BackColorPicker"></kendo-toolbar-colorpicker>

    <kendo-editor-insert-table-button *ngIf="configuration.InsertTableButton"></kendo-editor-insert-table-button>

    <kendo-toolbar-buttongroup>
      <kendo-toolbar-button
        kendoEditorAddColumnBeforeButton
        *ngIf="configuration.AddColumnBeforeButton"
      ></kendo-toolbar-button>
      <kendo-toolbar-button
        kendoEditorAddColumnAfterButton
        *ngIf="configuration.AddColumnAfterButton"
      ></kendo-toolbar-button>
      <kendo-toolbar-button
        kendoEditorAddRowBeforeButton
        *ngIf="configuration.AddRowBeforeButton"
      ></kendo-toolbar-button>
      <kendo-toolbar-button kendoEditorAddRowAfterButton *ngIf="configuration.AddRowAfterButton"></kendo-toolbar-button>
      <kendo-toolbar-button
        kendoEditorDeleteColumnButton
        *ngIf="configuration.DeleteColumnButton"
      ></kendo-toolbar-button>
      <kendo-toolbar-button kendoEditorDeleteRowButton *ngIf="configuration.DeleteRowButton"></kendo-toolbar-button>
    </kendo-toolbar-buttongroup>
  </kendo-toolbar>
</kendo-editor>

<ng-container *ngIf="showErrorMessage">
  <div class="error-message">
    {{ referenceDataConstants.ERROR_MESSAGE_ME000 | localizeErrorMessage : 'CaseMessageContent' }}
  </div>
</ng-container>

<div class="buttons__bar buttons__bar_right button-container">
  <button
    (click)="sendMessage()"
    class="primary-button vo-primary-button-1 mt-30 mt-md-15 mb-60 vo-button--mobile-100"
    [boiPermissionChecker]="[userPermissions.AddCaseNote]"
  >
    {{ sendMessageLabel | localizeLabel }}
  </button>
</div>
